import React, {useEffect, useRef, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {getTempUrl} from "../../../redux/api/apiMonitoringList";
import AudioPlayerComponent from 'react-h5-audio-player';
import {ProgressBar} from "primereact/progressbar";

const AudioPlayer = (props: any) => {
    const dispatch = useAppDispatch();
    // @ts-ignore
    const isSpeakingAudio = useAppSelector(state => state.MonitoringListReducer.isSpeakingAudio);
    const monitoringData = useAppSelector(state => state.MonitoringListReducer?.monitoringData);
    const audioPlayer2 = useRef<any>(null);
    const lastReportedTimeMsRef = useRef(0);
    const onPlaybackTimeUpdateRef = useRef(props.onPlaybackTimeUpdate);
    const onPlaybackSeekRef = useRef(props.onPlaybackSeek);
    const [key, setKey] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const notFoundError = useAppSelector(state => state.NotificationsReducer.notFoundError);
    const audioUnavailable = useAppSelector(state => state.MonitoringListReducer.audioUnavailable);
    const audioUrl = props.audioUrl;
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const audioType1 = audioUrl?.filter((item: { audioType: number; }) => item?.audioType === 1);
    const audioType2 = audioUrl?.filter((item: { audioType: number; }) => item?.audioType === 2);
    const src = isSpeakingAudio?.code === 1
        ? audioType1?.[0]?.tempUrl
        : isSpeakingAudio?.code === 2
            ? audioType2?.[0]?.tempUrl
            : null;
    const MAX_RETRY = 1;
    const [retryCount, setRetryCount] = useState(0);

    useEffect(() => {
        onPlaybackTimeUpdateRef.current = props.onPlaybackTimeUpdate;
        onPlaybackSeekRef.current = props.onPlaybackSeek;
    }, [props.onPlaybackTimeUpdate, props.onPlaybackSeek]);

    const notifyPlaybackTime = (timeMs: number, isSeek = false) => {
        lastReportedTimeMsRef.current = timeMs;
        onPlaybackTimeUpdateRef.current?.(timeMs);

        if (isSeek) {
            onPlaybackSeekRef.current?.(timeMs);
        }
    };

    const handleAudioSeek = (event: Event) => {
        const audioElement = event.currentTarget as HTMLAudioElement;
        notifyPlaybackTime(audioElement.currentTime * 1000, true);
    };

    useEffect(() => {
        if (props.timeStamp == null || !audioUrl?.length) {
            return;
        }

        const audioElement = audioPlayer2.current?.audio?.current;
        if (!audioElement) {
            return;
        }

        audioElement.currentTime = props.timeStamp / 1000;
        void audioElement.play().catch(() => {});
    }, [audioUrl, isSpeakingAudio, props.timeStamp, props.seekNonce]);

    useEffect(() => {
        if (props.isActive !== false) {
            return;
        }

        const audioElement = audioPlayer2.current?.audio?.current;
        if (!audioElement) {
            return;
        }

        audioElement.pause();
        audioElement.currentTime = 0;
        lastReportedTimeMsRef.current = 0;
        props.onPlaybackTimeUpdate?.(0);
    }, [props.isActive, props.onPlaybackTimeUpdate]);

    const handlePlayError = (e: any) => {
        if (
            retryCount < MAX_RETRY
            && !notFoundError
            && !audioUnavailable
            && jwtToken?.jwtToken
            && monitoringData?.sessionId
        ) {
            props.setTimeStamp(e.target.currentTime * 1000);
            dispatch(getTempUrl(jwtToken?.jwtToken, monitoringData?.sessionId, monitoringData?.id));
            setKey(prevKey => prevKey + 1);
            setRetryCount(prev => prev + 1);
        }
    };

    useEffect(() => {
        if (audioUrl?.length > 0) {
            setRetryCount(0);
        }
    }, [audioUrl]);

    const handleTimeUpdate = (e: any) => {
        const timeMs = e.target.currentTime * 1000;
        const timeJumpMs = Math.abs(timeMs - lastReportedTimeMsRef.current);
        const isSeekJump = timeJumpMs > 500;

        notifyPlaybackTime(timeMs, isSeekJump);
    };

    const handleWaiting = () => {
        setIsLoading(true);
    };

    const handlePlaying = () => {
        setIsLoading(false);
    };

    return (
        <>
            {isLoading && <ProgressBar mode="indeterminate" style={{height: '3px'}}></ProgressBar>}
            <AudioPlayerComponent
                ref={audioPlayer2}
                key={key}
                className={`${isLoading && 'opacity-50'}`}
                autoPlay={props.autoPlay !== false}
                showDownloadProgress={false}
                onWaiting={handleWaiting}
                onError={handlePlayError}
                autoPlayAfterSrcChange={props.autoPlay !== false}
                onPlaying={handlePlaying}
                onListen={handleTimeUpdate}
                onSeeking={handleAudioSeek}
                onSeeked={handleAudioSeek}
                listenInterval={500}
                src={src ?? null}
            />
        </>
    );
};

export default AudioPlayer;
